import { Logger, LoggerService } from "@Shared/logger";
import {PipelineContext, PipelineStep} from "@Modules/pipeline_module/_base";
import {Auth0Repository} from "@Modules/auth_module";
import {MaybeUpdateSessionServerStep} from "@Modules/pipeline_module/steps/session/update-session.step";
import { OptionsModule } from "@Modules/options_module";
import { CheckEntitlementStep } from "../entitlement/check-entitlement.step";
import { buildPostCallbackStep } from "./check-auth-status.step";

export class Auth0AuthenticatedStep implements PipelineStep {
    private auth0Repository: Auth0Repository;
    private Logger: Logger = LoggerService.createLogger("Auth0AuthenticatedStep");

    async execute(context: PipelineContext): Promise<PipelineStep | null> {
        this.Logger.trace("Executing....");
        this.auth0Repository = Auth0Repository.Instance;
        this.Logger.trace("Options Module", OptionsModule.Options);
        context.sessionServerNeedsUpdate = !this.auth0Repository.localStorageAuthSessionExists();
        
        // return check entitlement step
        if (OptionsModule.Options.entitlement.check) {
            return new CheckEntitlementStep();
        } else if(OptionsModule.Options.session.enabled){
            return new MaybeUpdateSessionServerStep();
        }
        // No entitlement/session steps to run, but the /callback round-trip (Apple News + generic
        // auth_redirect) still needs to complete. No-op off /callback, so safe to chain.
        return buildPostCallbackStep();
    }
} 